import { render, staticRenderFns } from "./BasicSetting.vue?vue&type=template&id=32d03f0b&scoped=true"
import script from "./BasicSetting.vue?vue&type=script&lang=js"
export * from "./BasicSetting.vue?vue&type=script&lang=js"
import style0 from "./BasicSetting.vue?vue&type=style&index=0&id=32d03f0b&lang=scss&scoped=true"
import style1 from "./BasicSetting.vue?vue&type=style&index=1&id=32d03f0b&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d03f0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32d03f0b')) {
      api.createRecord('32d03f0b', component.options)
    } else {
      api.reload('32d03f0b', component.options)
    }
    module.hot.accept("./BasicSetting.vue?vue&type=template&id=32d03f0b&scoped=true", function () {
      api.rerender('32d03f0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/sysParam/BasicSetting.vue"
export default component.exports